import React, { useEffect, useState } from 'react';
import './Navbar.css';
import { NavLink, useHistory } from 'react-router-dom';
import axios from 'axios';
const Navbar = () => {
  const [navbar, setNavbar] = useState(false);
  const [data, setData] = useState([]);
  const his = useHistory();
  const openNav = () => {
    document.getElementById('mySidenav').style.width = '100%';
  };
  const closeNav = () => {
    document.getElementById('mySidenav').style.width = '0';
  };
  const Home = () => {
    closeNav();
    his.push('/');
  };
  const Services = () => {
    closeNav();
    his.push('/projects');
  };
  const About = () => {
    closeNav();
    his.push('/about');
  };

  const Contact = () => {
    closeNav();
    his.push('/contact');
  };

  const getdata = async () => {
    const res = await axios.get(
      'https://portfolio-node-7hlx.onrender.com/getabout'
    );
    setData(res.data);
  };
  useEffect(() => {
    getdata();
  }, []);

  useEffect(() => {
    const changeBg = () => {
      // console.log(window.scrollY)
      if (window.scrollY >= 100) {
        setNavbar(true);
      } else {
        setNavbar(false);
      }
    };

    window.addEventListener('scroll', changeBg);
    return () => window.removeEventListener('scroll', changeBg);
  }, []);
  // window.addEventListener('scroll',)

  return (
    <>
      <header className={navbar ? ' bgprimary fixed-top' : 'bg-dark fixed-top'}>
        <div className="nav_wraper">
          <div className="navbar-box">
            <div className="logo">
              <NavLink to="/">
                <h3 className="text-white">MATANU</h3>
              </NavLink>
            </div>
            <div className="nav-box">
              <p></p>
              <div className="navbtn">
                {/* <button className=>Call Now</button> */}
                {data?.map((val, ind) => (
                  <a
                    key={ind}
                    href={`tel:${val.phone}`}
                    className={
                      navbar ? 'btn btn-outline-dark' : 'btn btn-outline-light'
                    }
                  >
                    Call Now
                  </a>
                ))}
                <div className="barss">
                  <i className="fa fa-bars" onClick={openNav}></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <div id="mySidenav" class="sidenav">
        <a href="javascript:void(0)" class="closebtn" onClick={closeNav}>
          &times;
        </a>
        <p onClick={Home}>Home</p>
        <p onClick={About}>About</p>
        <p onClick={Services}>Projects</p>
        <p onClick={Contact}>Contact</p>
      </div>
    </>
  );
};

export default Navbar;
